import { useEffect, useState } from 'react'
import { useApiClient } from '@hooks'
import { SignForwardApiClient } from 'api'

export function useSignForwardEligibility(cvr: string | undefined, agreementCode: number | undefined) {
    const signForwardApi = useApiClient((b) => new SignForwardApiClient(b))
    const [isEligible, setIsEligible] = useState(false)

    useEffect(() => {
        let cancelled = false

        if (!cvr || !agreementCode) {
            setIsEligible(false)
            return
        }

        signForwardApi.getEligibility(cvr, agreementCode)
            .then(result => { if (!cancelled) setIsEligible(result) })
            .catch(() => { if (!cancelled) setIsEligible(false) })

        return () => { cancelled = true }
    }, [cvr, agreementCode])

    return isEligible
}
